import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
// import Head from "next/head"; // Eliminado porque no es Next.js

import HeroComex from "./HeroComex";
import BeneficiosComex from "./BeneficiosComex";
import MarcasConfian from "./MarcasConfian";
import HeroContacto from "./HeroContacto";
import TestimoniosComex from "./TestimoniosComex";
import VideoComex from "./VideoComex";
import Seo from "./Seo";
import GetInTuch from "./getInTuch";

export default function Ejemplo1(props) {
  // Props directos de Strapi
  const {
    hero,
    box,
    beneficio,
    marcas,
    video,
    testimonio,
    seo,
    titulo_box_2,
    titulo_box_1,
  } = props;
  const breakpoints = {
    0: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
    420: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 1.2, spaceBetween: 30 },
    768: { slidesPerView: 1.5, spaceBetween: 30 },
    1024: { slidesPerView: 2, spaceBetween: 40 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
    1600: { slidesPerView: 4, spaceBetween: 40 },
    2000: { slidesPerView: 4, spaceBetween: 40 },
  };

  const renderTextNode = (node, key) => {
    const { text, bold, italic } = node;

    if (!text) return null;

    let element = <span key={key}>{text}</span>;

    if (bold && italic) {
      element = (
        <strong key={key}>
          <em>{text}</em>
        </strong>
      );
    } else if (bold) {
      element = <strong key={key}>{text}</strong>;
    } else if (italic) {
      element = <em key={key}>{text}</em>;
    }

    return element;
  };

  return (
    <>
      {/* SEO */}

      {Array.isArray(seo) && seo[0] ? (
        <Seo
          metaTitle={seo[0]?.metatitle}
          metaDescription={seo[0]?.metadescription}
          metaImage={seo[0]?.metaimage?.url}
          metaKeywords={seo[0]?.metakeywords}
          canonicalURL={seo[0]?.canonicalurl}
        />
      ) : null}

      <main className=" bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-white">
        {/* Hero */}
        <div className="">
          {hero?.length ? (
            hero.map((item, index) => (
              <HeroComex
                key={item.id || index}
                titulo={item.titulo || ""} // Aseguramos que sea texto
                subtitulo={item.text || ""} // Aseguramos que sea texto
                video={item?.video?.url}
                imagen={item?.img?.formats?.thumbnail?.url || item.img?.url}
              />
            ))
          ) : (
            <HeroComex titulo="Cargando..." subtitulo="Espere un momento" />
          )}
        </div>

        {/* Video */}
        {video?.length > 0 && (
          <section className="">
            <VideoComex
              key={video[0].id}
              video={video[0].video?.url}
              controls={video[0]?.control}
              autoPlay={video[0]?.autoplay}
              muted={video[0]?.muted}
              loop={video[0]?.loop}
            />
          </section>
        )}

        {/* Beneficios */}
        {beneficio?.length > 0 && (
          <section className=" ">
            <div className="container">
              <h1 className="text-left text-3xl md:text-[40px] lg:text-[45px] leading-tight px-2 md:px-0 lg:px-0 font-extrabold text-sidom-orange mb-8">
                {titulo_box_1 &&
                titulo_box_1.titulo &&
                Array.isArray(titulo_box_1.titulo) &&
                titulo_box_1.titulo[0]?.children
                  ? titulo_box_1.titulo[0].children.map((child, index) =>
                      renderTextNode(child, index)
                    )
                  : null}
              </h1>
            </div>
            <div className="relative container mb-[30px]">
              <Swiper
                spaceBetween={30}
                speed={8000}
                autoplay={{
                  delay: 1,
                  disableOnInteraction: false,
                  reverseDirection: true,
                }}
                centeredSlides={true}
                onSwiper={(swiper) => swiper.slideTo(0, 0)}
                modules={[Autoplay, Pagination, Navigation]}
                breakpoints={breakpoints}
                className="mySwiper"
              >
                {beneficio.map((item, index) => (
                  <SwiperSlide key={item.id}>
                    <BeneficiosComex
                      key={item.id || index}
                      icon={
                        item.icon?.formats?.thumbnail?.url || item.icon?.url
                      }
                      titulo={item.titulo}
                      subtitulo={item.subtitulo}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </section>
        )}

        {/* Marcas */}
        {Array.isArray(marcas) &&
          marcas[0] &&
          marcas[0].img &&
          marcas[0].img.length > 0 && (
            <section className=" bg-sidom-blue text-center">
              <MarcasConfian
                key={marcas[0].id || marcas[0].index}
                titulo={marcas[0].titulo}
                marcas={marcas[0].img}
              />
            </section>
          )}
        {/* Box de contacto */}
        {box?.length > 0 && (
          <section className="">
            <div>
              {box.map((item, index) => (
                <HeroContacto
                  key={item.id || index}
                  titulo={item.titulo}
                  buttonText={item.boton}
                  url={item.url}
                  svg={item.svg?.formats?.thumbnail?.url || item.svg?.[0]?.url}
                  img={item.img?.formats?.thumbnail?.url || item.img?.[0]?.url}
                />
              ))}
            </div>
          </section>
        )}
        {/* testimonio */}
        {testimonio?.length > 0 && (
          <section className="mb-[70px] md:mb-[100px] lg:mb-[90px] ">
            <TestimoniosComex testimonios={testimonio} titulo={titulo_box_2} />
          </section>
        )}
        {/* formulario */}
        <section className="">
          <GetInTuch />
        </section>
      </main>
    </>
  );
}
